import React from "react";
import { FaSearch } from "react-icons/fa";
import Pagination from "../../../helper/Pagination";

const ItOemPartnersTable = ({
  partners,
  loading,
  currentPage,
  pagination,
  searchTerm,
  statusFilter,
  handleSearchChange,
  setStatusFilter,
  setCurrentPage,
  onRowClick,
}) => {
  return (
    <div className="table-section">
      <div className="d-flex justify-content-between gap-4 align-items-center mb-2">
        <div>
          <button
            className={`me-2 add-btn ${
              statusFilter === "active" ? "active" : ""
            }`}
            onClick={() =>
              setStatusFilter(statusFilter === "active" ? "" : "active")
            }
            style={{
              background:
                statusFilter === "active"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "inactive"
                  ? "#f8f9fa"
                  : "",
              color:
                statusFilter === "active"
                  ? "white"
                  : statusFilter === "inactive"
                  ? "#666"
                  : "",
            }}
          >
            Active
          </button>
          <button
            className={`add-btn ${statusFilter === "inactive" ? "active" : ""}`}
            onClick={() =>
              setStatusFilter(statusFilter === "inactive" ? "" : "inactive")
            }
            style={{
              background:
                statusFilter === "inactive"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "active"
                  ? "#f8f9fa"
                  : "",
              color:
                statusFilter === "inactive"
                  ? "white"
                  : statusFilter === "active"
                  ? "#666"
                  : "",
            }}
          >
            Inactive
          </button>
        </div>

        <div className="position-relative">
          <input
            type="search"
            placeholder="Search by Name & Email..."
            className="form-input"
            value={searchTerm}
            onChange={handleSearchChange}
            style={{ width: "200px" }}
          />
          {searchTerm === "" && (
            <div
              className="position-absolute"
              style={{
                top: "50%",
                right: "13px",
                color: "#666",
                transform: "translateY(-50%)",
              }}
            >
              <FaSearch />
            </div>
          )}
        </div>
      </div>

      <div className="table-scroll-wrapper">
        <table className="partners-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Logo</th>
              <th>Company Name</th>
              <th>Contact Person</th>
              <th>Email</th>
              <th>Contact Number</th>
              <th>Country (Currency)</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#666",
                  }}
                >
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </td>
              </tr>
            ) : partners.length === 0 ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                  }}
                >
                  No OEM partners found
                </td>
              </tr>
            ) : (
              partners.map((partner, index) => (
                <tr
                  key={partner._id}
                  style={{ cursor: onRowClick ? "pointer" : "default" }}
                >
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    {(currentPage - 1) * 10 + index + 1}
                  </td>
                  <td>
                    {partner.logo && (
                      <img
                        src={partner.logo}
                        alt={partner.companyName}
                        className="me-2"
                        style={{
                          height: "30px",
                          width: "32px",
                          objectFit: "contain",
                          borderRadius: "4px",
                          backgroundColor: "#c5c7caff",
                        }}
                      />
                    )}
                  </td>
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    <div className="">
                      <span>{partner.companyName || "N/A"}</span>
                    </div>
                  </td>
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    {partner.firstName && partner.lastName
                      ? `${partner.firstName} ${partner.lastName}`
                      : "N/A"}
                  </td>
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    {partner.email || "N/A"}
                  </td>
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    {partner.countryCode && partner.contactNumber
                      ? `(${partner.countryCode}) ${partner.contactNumber}`
                      : partner.contactNumber || "N/A"}
                  </td>
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    {partner.country && partner.currency
                      ? `${partner.country} (${partner.currency})`
                      : partner.country || partner.currency || "N/A"}
                  </td>

                  <td>
                    <span
                      className={`badge ${
                        partner.status === "active"
                          ? "bg-success"
                          : "bg-secondary"
                      }`}
                    >
                      {partner.status}
                    </span>
                  </td>
                  <td onClick={() => onRowClick && onRowClick(partner)}>
                    {new Date(partner.createdAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={pagination.totalPages}
        totalItems={pagination.totalItems}
        itemsPerPage={pagination.itemsPerPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default ItOemPartnersTable;
